// extracted by mini-css-extract-plugin
module.exports = {"completed":"todo_completed__2wYws","editTodo":"todo_editTodo__2fCiD","listItem":"todo_listItem__G6c62"};